var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "smallAdd",
    d: "M6 0c.61 0 1.1.49 1.1 1.1v3.8h3.8c.61 0 1.1.49 1.1 1.1s-.49 1.1-1.1 1.1H7.1v3.8c0 .61-.49 1.1-1.1 1.1s-1.1-.49-1.1-1.1V7.1H1.1C.49 7.1 0 6.61 0 6s.49-1.1 1.1-1.1h3.8V1.1C4.9.49 5.39 0 6 0Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallAdd);
export default __webpack_public_path__ + "static/media/smallAdd.8a779fb66aecc6ff14b6b4b8bf0036a8.svg";
export { ForwardRef as ReactComponent };